import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const WebPushSend16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.10938 3.35938C1.10938 2.11673 2.11673 1.10938 3.35938 1.10938H12.6406C13.8833 1.10938 14.8906 2.11673 14.8906 3.35938V10.1094C14.8906 11.352 13.8833 12.3594 12.6406 12.3594H10.3515L10.5859 13.7656H11.375C11.6857 13.7656 11.9375 14.0175 11.9375 14.3281C11.9375 14.6388 11.6857 14.8906 11.375 14.8906H4.625C4.31434 14.8906 4.0625 14.6388 4.0625 14.3281C4.0625 14.0175 4.31434 13.7656 4.625 13.7656H5.41412L5.6485 12.3594H3.35938C2.11673 12.3594 1.10938 11.352 1.10938 10.1094V3.35938ZM2.23438 3.35938C2.23438 2.73805 2.73805 2.23438 3.35938 2.23438H12.6406C13.2619 2.23438 13.7656 2.73805 13.7656 3.35938V8.98438H2.23438V3.35938ZM12.6406 11.2344C13.2619 11.2344 13.7656 10.7307 13.7656 10.1094H2.23438C2.23438 10.7307 2.73805 11.2344 3.35938 11.2344H12.6406ZM6.78901 12.3594L6.55464 13.7656H9.44537L9.21099 12.3594H6.78901Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
